// extracted by mini-css-extract-plugin
export default {"container":"SM34m","insiderClass":"jDNiv","nextClass":"F5Zsb"};